// Shared numeric and currency formatting helpers
// Use across header, summary, and other components

export const formatNumber = (n?: number | null, digits = 2): string => {
  if (n === null || n === undefined || isNaN(Number(n))) return '—';
  const num = Number(n);
  const abs = Math.abs(num);
  if (abs >= 1e12) return (num / 1e12).toFixed(digits) + 'T';
  if (abs >= 1e9) return (num / 1e9).toFixed(digits) + 'B';
  if (abs >= 1e6) return (num / 1e6).toFixed(digits) + 'M';
  if (abs >= 1e3) return (num / 1e3).toFixed(digits) + 'K';
  
  return num.toFixed(digits);
};

export const formatCurrency = (n?: number | null, currency: string = 'USD'): string => {
  if (n === null || n === undefined || isNaN(Number(n))) return '—';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(Number(n));
  } catch {
    return `${formatNumber(Number(n), 2)} ${currency}`;
  }
};
